var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adv-listing-filters-clear"},[_c('a',{staticClass:"adv-listing-filters-clear-btn",attrs:{"href":_vm.getUrlNoFilters}},[_vm._v(_vm._s(_vm.t('filters.clear.all')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }